import { useFormatCurrency } from "@dgs/core";
import styled from "styled-components";
import { EventBudgetAnalyticsCostResource } from "../analyticsTypes";

const Currency = styled.span`
	font-weight: ${({ theme }) => theme.fonts.weights.bold};
	text-transform: uppercase;
`;

interface Props {
	costsWithCurrency: EventBudgetAnalyticsCostResource;
}

export function CostPerCurrency({ costsWithCurrency }: Props) {
	const formatCurrency = useFormatCurrency(costsWithCurrency.currency);
	return (
		<div>
			<Currency>{costsWithCurrency.currency.isoCode}</Currency>: {formatCurrency(costsWithCurrency.costs)}
		</div>
	);
}
